<div class="main-container">
    <div class="header-container">
        <p *ngIf="supplierTax?.TaxCountry" i18n="@@EditTax" t="EditTax">Edit Tax</p>
        <p *ngIf="!supplierTax?.TaxCountry" i18n="@@AddTax" t="AddTax">Add Tax</p>
    </div>
    <tax-edit #taxEditComponent class="tax-edit" [tsl-supplierCode]="supplierCode" [tsl-requiredDocuments]="requiredDocuments"
      [tsl-supplierTax]="supplierTax" [tsl-taxDocuments]="taxDocuments" [tsl-readOnly]="readOnly"
      [tsl-generalSettings]="settings$ | async" [tsl-countries]="taxCountries$ | async"
      [tsl-taxIDTypes]="taxIdTypes$ | async" [tsl-isReactivation]="true" [tsl-hideSaveButton]="true" [tsl-hideCancelButton]="true"
      (tsl-onSave)="taxFormSubmit($event.supplierTaxInfo)" (tsl-onSaveError)="setErrorMessage($event.errorMessage)"
      [tsl-enableDocumentSectionValidationBasedOnFieldModification]= "true"
      [tsl-taskStatus]="taskStatus">
    </tax-edit>
    <div class="button-container">
        <button class="action-btn" tsl-button size="small" color="black" unfilled (click)="onClose()"
            i18n="@@Cancel" t="Cancel">Cancel</button>
        <button *ngIf="!readOnly" class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit()"
            i18n="@@Submit" t="Submit">Submit</button>
    </div>
</div>